import moment from 'moment';
import { openPrintWindow, escapeHtml } from '../MedicineOrders/printDispenseAuthorization';
import { buildMinistryPrintHtml } from '../../Shared/printLayout';

function fmtDate(v) {
    if (!v) return '—';
    try { return moment(v).format('YYYY/MM/DD HH:mm'); } catch { return '—'; }
}

export function buildNonFormularyRequestHtml(detail) {
    const approvals = (detail.approvals || []).map((row, index) => `
        <tr class="${index % 2 === 0 ? 'bg-gray-striped-1' : 'bg-gray-striped-2'}">
            <td>${index + 1}</td>
            <td>${Number(row.stepNo || index + 1)}</td>
            <td>${escapeHtml(row.requiredRoleLabel || row.requiredRole || '—')}</td>
            <td>${escapeHtml(row.decisionLabel || '—')}</td>
            <td>${escapeHtml(row.note || '—')}</td>
        </tr>`).join('');

    const infoHtml = `
        <div class="col-6">
          <table class="table table-sm table-bordered mb-2 meta-table">
            <tbody>
              <tr class="bg-gray-striped-1"><th>الصنف</th><td>${escapeHtml(detail.requestedProductName || detail.productName || '—')}</td></tr>
              <tr class="bg-gray-striped-2"><th>المرفق</th><td>${escapeHtml(detail.branchName || '—')}</td></tr>
              <tr class="bg-gray-striped-1"><th>الحالة</th><td>${escapeHtml(detail.statusLabel || '—')}</td></tr>
              <tr class="bg-gray-striped-2"><th>المبرر</th><td>${escapeHtml(detail.justification || '—')}</td></tr>
            </tbody>
          </table>
        </div>
        <div class="col-6">
          <table class="table table-sm table-bordered mb-2 meta-table">
            <tbody>
              <tr class="bg-gray-striped-1"><th>ملاحظة الوزارة</th><td>${escapeHtml(detail.ministryPharmacyNote || '—')}</td></tr>
              <tr class="bg-gray-striped-2"><th>أنشئ</th><td>${escapeHtml(fmtDate(detail.createdOn))} - ${escapeHtml(detail.createdByName || '—')}</td></tr>
              <tr class="bg-gray-striped-1"><th>القرار النهائي</th><td>${escapeHtml(fmtDate(detail.ministryDecidedOn))} - ${escapeHtml(detail.decidedByName || '—')}</td></tr>
            </tbody>
          </table>
        </div>`;

    const bodyHtml = `
      <table class="table table-sm table-bordered text-center align-middle">
        <thead>
          <tr class="bg-gray"><th>#</th><th>الخطوة</th><th>الدور</th><th>القرار</th><th>الملاحظة</th></tr>
        </thead>
        <tbody>${approvals || '<tr><td colspan="5" class="text-center">لا توجد بيانات اعتماد</td></tr>'}</tbody>
      </table>`;

    const signaturesHtml = `
        <div class="col-4"><p><strong>المرفق الطالب</strong><br/>الاسم: ............................<br/>التوقيع: ............................</p></div>
        <div class="col-4"><p><strong>اعتماد الجهة المختصة</strong><br/>الاسم: ............................<br/>التوقيع والختم: ............................</p></div>
        <div class="col-4"><p><strong>الختم الرسمي</strong><br/>الاسم: ............................<br/>التوقيع: ............................</p></div>`;

    return buildMinistryPrintHtml({
        title: 'طلب صنف خارج القائمة النمطية',
        docRef: detail.code || detail.id || detail.requestedProductName || '',
        infoHtml,
        bodyHtml,
        signaturesHtml,
        footerSummary: 'وثيقة طلب استثناء دوائي تُستخدم لعرض مبررات طلب صنف خارج القائمة النمطية واعتماد قرار الجهة المختصة.',
        footerMeta: `مرجع الطلب: <strong>${escapeHtml(detail.code || String(detail.id || ''))}</strong>`
    });
}

export function printNonFormularyRequest(detail) {
    return openPrintWindow(buildNonFormularyRequestHtml(detail));
}
